import { Component, OnInit ,Input} from '@angular/core';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { FAQ } from 'src/app/models/um/organization';
import { CommonService } from 'src/app/services/common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-help-view',
  templateUrl: './help-view.component.html',
  styleUrls: ['./help-view.component.scss']
})
export class HelpViewComponent implements OnInit {
 @Input() public Content: any;
  content: any;
  faqs: FAQ[];
  user_type;
  userDetails : any
  grantFeatures: any[] = [];
  ISTFeatures: any[] = [];
  program:any;
  orgDetails: any;
  ISTname : any
  EAPname : any
  Grantsname : any
  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private userService : UserService,
    private https: HttpClient
  ) { }

  ngOnInit() {
    this.user_type = this.userService.getUserType();
    this.userDetails = this.userService.getUserDetais();
    this.orgDetails = this.commonService.getOrgDetails();
    if(this.orgDetails!=null && this.orgDetails!=undefined)
    {
    this.ISTname = this.orgDetails[0].IST_DISPLAY_NAME;
    this.EAPname = this.orgDetails[0].EAP_DISPLAY_NAME;
    this.Grantsname = this.orgDetails[0].GRANTS_DISPLAY_NAME;
    }

  }

}
